// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAsiSEYPw1fDYq6YR7RDkHKBN0twcrk48I",
  authDomain: "vanya-website.firebaseapp.com",
  projectId: "vanya-website",
  storageBucket: "vanya-website.appspot.com",
  messagingSenderId: "637509806895",
  appId: "1:637509806895:web:206ecb4218c70d126e0fda",
  measurementId: "G-T0GC4LSF6Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);